import { ACTIVE_TAB_ID } from '../../constants/followers';
import { createContext } from './context';
import model from './model';
import { bindDemoData } from './services/demo-mode';

export default model.createController(({ $bind, $w, flowAPI, initState }) => {
  return {
    pageReady: async () => {
      const { environment, translations } = flowAPI;
      const { isBlocksPreview, isEditor } = environment;
      const { t } = translations;
      const { state, lightboxContext, currentMemberId } = createContext({
        flowAPI,
        initState,
      });

      const defaultTab = lightboxContext?.activeTab ?? ACTIVE_TAB_ID.Followers;

      const shouldShowFollowUnfollowButtons = Boolean(
        lightboxContext?.onFollowingChange,
      );

      // @ts-expect-error
      $w('#tabs').changeTab(defaultTab);

      $bind('#wrapperMsb', {
        currentState: () => {
          return state.wrapperMsbState;
        },
      });

      if (isEditor) {
        return bindDemoData(state, $bind, t);
      }

      if (isBlocksPreview || !lightboxContext) {
        return;
      }

      $bind('#title', {
        text: () => lightboxContext.title,
      });

      $bind('#errorText', {
        text: () => state.errorMessage,
      });

      $bind('#closeButton', {
        // @ts-expect-error
        accessibility: {
          ariaAttributes: {
            label: () => t('app.ffmodal.header.close'),
          },
        },
        onClick: () => {
          const wixCodeAPI = flowAPI.controllerConfig.wixCodeApi;
          const lightboxAPI = wixCodeAPI.window.lightbox as {
            close?: Function;
          };

          return lightboxAPI.close?.();
        },
      });

      $bind('#followers', {
        // @ts-expect-error
        label: () => t('app.ffmodal.tab.followers'),
      });

      $bind('#following', {
        // @ts-expect-error
        label: () => t('app.ffmodal.tab.following'),
      });

      $bind('#followingMsb', {
        currentState: () => {
          return state.following.members.length > 0
            ? 'followingContent'
            : 'followingEmptyState';
        },
      });

      $bind('#followersMsb', {
        currentState: () => {
          return state.followers.members.length > 0
            ? 'followersContent'
            : 'followersEmptyState';
        },
      });

      $bind('#followersEmptyStateMsb', {
        currentState: () => {
          return currentMemberId === lightboxContext.memberId
            ? 'followersEmptyStateYourself'
            : 'followersEmptyStateOthers';
        },
      });

      $bind('#followingEmptyStateMsb', {
        currentState: () => {
          return currentMemberId === lightboxContext.memberId
            ? 'followingEmptyStateYourself'
            : 'followingEmptyStateOthers';
        },
      });

      $bind('#followersEmptyStateYourselfText', {
        text: () => t('app.ffmodal.empty-state.followers-yourself'),
      });

      $bind('#followersEmptyStateOthersText', {
        text: () => {
          return t('app.ffmodal.empty-state.followers-others', {
            memberName: lightboxContext.title,
          });
        },
      });

      $bind('#followingEmptyStateYourselfText', {
        text: () => t('app.ffmodal.empty-state.following-yourself'),
      });

      $bind('#followingEmptyStateOthersText', {
        text: () => {
          return t('app.ffmodal.empty-state.following-others', {
            memberName: lightboxContext.title,
          });
        },
      });

      $bind('#ffList1', {
        shouldShowFollowUnfollowButtons: () => shouldShowFollowUnfollowButtons,
        // @ts-expect-error
        members: () => state.following.members,
        // @ts-expect-error
        onMemberFollowed: ({ data: memberId }) => {
          return state.followMember(memberId);
        },
        // @ts-expect-error
        onMemberUnfollowed: ({ data: memberId }) => {
          return state.unfollowMember(memberId);
        },
        onLastMemberShown: () => {
          return state.fetchFollowing(lightboxContext.memberId);
        },
      });

      $bind('#ffList2', {
        shouldShowFollowUnfollowButtons: () => shouldShowFollowUnfollowButtons,
        // @ts-expect-error
        members: () => state.followers.members,
        // @ts-expect-error
        onMemberFollowed: ({ data: memberId }) => {
          return state.followMember(memberId);
        },
        // @ts-expect-error
        onMemberUnfollowed: ({ data: memberId }) => {
          return state.unfollowMember(memberId);
        },
        onLastMemberShown: () => {
          return state.fetchFollowers(lightboxContext.memberId);
        },
      });

      state.fetchFollowingFollowers(lightboxContext.memberId);
    },
    exports: {},
  };
});
